import styled from "styled-components";

export const ConflictBtn = styled.button`
  background-color: rgb(20, 124, 194);
  border: 1px solid #fff;
  padding: 5px 20px;
  height: 35px;
  color: #fff;
  margin: 0 10px;
`;
